import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../components/auth/AuthRequiredRoute/AuthRequiredRoute";
import Button from "../../components/ui/Button/Button";
import Icon from "../../components/ui/Icon/Icon";
import { useLoanInfo } from "../../features/loans/hooks/useLoanInfo";
import SuccessSection from "../EditMyLoan/SuccessSection";
import HeaderComponent from "../Header/HeaderComponent";
import styles from "./style.module.css";
import ConfirmSection from "../../components/common/ConfirmSection/ConfirmSection";
import { UpdateLoan } from "../../services/modules/loan";
import { useTranslation } from "react-i18next";

const AcceptAgreementDocumentPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("agreementPage");

  const { loanId } = useParams();

  const { userData } = useAuth();

  const { loanInfo } = useLoanInfo({ loanId, userData });

  const [isSuccess, setIsSuccess] = useState(false);
  
  const [showConfirmSection, setShowConfirmSection] = useState(false);
  
  const handleAccept = () => {
    setIsSuccess(true);
  };

  const handleCancel = async () => {
    await UpdateLoan({
      body: { loan_id: loanId, loan_state: "cancel" },
    });
    navigate(`/my-loans/${loanId}`);
  };

  return (
    <div className={styles.container}>
      <HeaderComponent
        title={t("pageTitle") }
        onBack={() => navigate(`/my-loans/${loanId}`)}
      />
      {showConfirmSection && (
        <ConfirmSection
          icon={<Icon size={72} name="ico-document-cancel" />}
          title={t("pageTitle") }
          descriptionLine1={t("cancelConfirmTitle") }
          descriptionLine2={t("cancelConfirmLine1") }
          confirmButtonText={t("cancelConfirmLine2") }
          cancelButtonText={t("confirmCancel") }
          onConfirm={handleCancel}
          onCancel={() => setShowConfirmSection(false)}
        />
      )}
      {isSuccess && (
        <SuccessSection
          icon={<Icon size={72} name="ico-document" />}
          title={t("successTitle") }
          descriptionLine1={t("successLine1") }
          descriptionLine2={t("successLine2") }
          onNext={async () => {
            await UpdateLoan({
              body: { loan_id: loanId, loan_state: "accept" },
            });
            navigate(`/my-loans/${loanId}`);
          }}
        />
      )}
      {!isSuccess && !showConfirmSection && (
        <main className={styles.content}>
          <h2 className={styles.loanTitle}>
            {t("loanNumber") } {loanInfo?.loan_name || "123-00456789-00"}
          </h2>
          <embed
            className={styles.pdf}
            src="/assets/loan-contract-example.pdf"
          />
          <footer className={styles.footer}>
            <Button
              onClick={() => setShowConfirmSection(true)}
              textColor={"#667085"}
              fullWidth
            >
              {t("cancelRequest") }
            </Button>
            <Button onClick={handleAccept} variant="primary" fullWidth>
              {t("accept") }
            </Button>
          </footer>
        </main>
      )}
    </div>
  );
};

export default AcceptAgreementDocumentPage;
